import React, { type FC } from "react";
import {
  useModalActions,
  useModalState,
} from "clientState/AuthFlow/providers/ModalScreenProvider";
import { Box, Flex } from "@edreamsodigeo/prisma-design-system";

import { type FooterProps } from "./contract";
import FooterDivider from "./FooterDivider";
import { FooterLink } from "./FooterLink";
import GeneralTC from "./GeneralTC";
import RecaptchaPrivacyPolicyLink from "./RecaptchaPrivacyPolicyLink";

const Footer: FC<FooterProps> = ({
  withRecaptchaPolicy = false,
  withGeneralTC = false,
  screen = "",
}) => {
  const { hasFooterLink, origin } = useModalState();
  const { closeModal } = useModalActions();

  return (
    <Flex flexDirection="column" alignItems="center" mt="base">
      {hasFooterLink && (
        <FooterLink
          onClick={closeModal}
          screen={screen}
          trackingPrefix={origin}
        />
      )}
      {withRecaptchaPolicy && !withGeneralTC && (
        <Box width="100%" mb="base">
          <FooterDivider />
        </Box>
      )}
      {withGeneralTC && <GeneralTC />}
      {withGeneralTC && withRecaptchaPolicy && (
        <Box width="104px" my="1x_small">
          <FooterDivider />
        </Box>
      )}
      {withRecaptchaPolicy && <RecaptchaPrivacyPolicyLink />}
    </Flex>
  );
};

export default Footer;
